import React, { useState } from 'react';
import './App.css';

function App() {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL;
  const API_USER = process.env.REACT_APP_API_USER;
  const API_PASS = process.env.REACT_APP_API_PASS;

  const handleFileChange = e => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setIsError(false);
    setMessage('');

    if (!file) {
      setIsError(true);
      setMessage('Pilih file CSV terlebih dahulu');
      return;
    }

    const formData = new FormData();
    formData.append('csv_file', file);

    const basicAuth = 'Basic ' + btoa(`${API_USER}:${API_PASS}`);

    try {
      const res = await fetch(`${API_URL}/transaksi-upload`, {
        method: 'POST',
        headers: {
          'Authorization': basicAuth,
        },
        body: formData,
      });

      const data = await res.json();

      if (data.success) {
        setMessage('Upload berhasil, ID Transaksi: ' + data.transaction_id);
        setIsError(false);
      } else {
        setMessage('Error: ' + data.message);
        setIsError(true);
      }
    } catch (err) {
      setMessage('Error koneksi ke server');
      setIsError(true);
    }
  };

  return (
    <div className="container">
      <h2>Upload File CSV Items Material</h2>
      <form onSubmit={handleSubmit}>
        <input type="file" accept=".csv" onChange={handleFileChange} />
        <button type="submit">Upload</button>
      </form>
      {message && (
        <p className={`message ${isError ? 'error' : 'success'}`}>
          {message}
        </p>
      )}
    </div>
  );
}

export default App;
